import { useMutation } from "@tanstack/react-query";
import { cloneUserShipApi } from "@/API/cloneUserShipApi";
import { ShipDataType } from "@/types/apiTypes";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";

export const useCloneUserShip = () => {
  const { invalidateShips } = useInvalidateQueries();

  return useMutation<ShipDataType, Error, string>({
    mutationFn: (shipId: string) => cloneUserShipApi(shipId),
    onSuccess: () => {
      invalidateShips();
      ShowNotification({
        title: "Ship Cloned",
        message: "Ship has been cloned successfully.",
        color: "success",
      });
    },
    onError: () => {
      ShowNotification({
        title: "Error",
        message: "Failed to clone the ship.",
        color: "error",
      });
    },
  });
};
